import { useState } from 'react';
import { withRouter } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import UserApi from 'api/user';
import SubmitButton from 'components/ui/buttons/SubmitButton';
import NotificationHelper from 'helpers/NotificationHelper';
import AuthHelper from '@youfy/shared/helpers/AuthHelper';

const UserAboutForm = ({ user }) => {
  const { t, i18n } = useTranslation();
  const [saving, setSaving] = useState(false);

  if (!user) {
    return null;
  }

  const onSubmit = async e => {
    e.preventDefault();

    const form_instance = new FormData(e.target);
    const form_entries = Object.fromEntries(form_instance);

    try {
      setSaving(true);
      await UserApi.update(user.id, form_entries);
      NotificationHelper.successUpdate();
    } finally {
      setSaving(false);
    }
  };

  const handleLanguageChange = e => {
    i18n.changeLanguage(e.target.value);
  };

  const logout = () => {
    AuthHelper.clearToken();
    window.location = '/';
  };

  return (
    <form className="card" onSubmit={onSubmit}>
      <div className="card-body">
        <h6 className="mb-3 col-md-8 text-muted text-uppercase">{t('profile.about_form.title')}</h6>
        <hr />
        <div className="form-group">
          <label htmlFor="inputName">{t('columns.name')}</label>
          <input
            type="text"
            disabled={saving}
            className="form-control"
            defaultValue={user.name}
            name="name"
            placeholder={t('profile.about_form.name_input.placeholder')}
            required
          />
        </div>

        <div className="form-group mt-3 mb-4">
          <label htmlFor="inputEmail">{t('columns.email')}</label>
          <input
            type="email"
            disabled={saving}
            className="form-control"
            defaultValue={user.email}
            name="email"
            placeholder={t('profile.about_form.email_input.placeholder')}
            required
          />
        </div>

        <div className="form-group mt-3 mb-4">
          <label htmlFor="inputEmail">{t('columns.lang')}</label>
          <select className="form-select form-control" value={i18n.language} onChange={handleLanguageChange}>
            <option value="ptBr">Português Brasil</option>
            <option value="en-US">English</option>
            <option value="es">Español</option>
          </select>
        </div>

        <hr />

        <div className="d-flex align-items-center justify-content-between mt-4 mb-4">
          <div className="d-flex align-items-center">
            <SubmitButton loading={saving} className="btn btn-primary" />
          </div>

          <div>
            {/* {this.getRemoveBtn()} */}
            <button type="button" className="btn btn-outline-danger" onClick={logout}>
              {t('keys.logout')}
            </button>
          </div>
        </div>
      </div>
    </form>
  );
};

export default withRouter(UserAboutForm);
